<template>
  <div>
    <Breadcrumbs main="Rehberler" title="Folyo" :links="breadLinks" />

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <b-card
            header-tag="div"
            header-bg-variant="primary"
            class="card-absolute"
          >
            <h5 slot="header">Folyo</h5>
            <b-card-body class="p-1">
              <RehberFolyo
                :rehber="rehber"
                v-if="isFolyoLoad"
                :noEdit="true"
              ></RehberFolyo>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import RehberFolyo from "@/components/c_rehber_folyo";

export default {
  data() {
    return {
      pageTitle: "Folyo",

      breadLinks: [],

      rehber: {},

      isFolyoLoad: false,
    };
  },
  mounted() {
    this.onDetay();
  },
  components: {
    RehberFolyo,
  },
  methods: {
    onDetay() {
      let vm = this;

      this.$connection.get("/rehberler/profil", function (response) {
        if (response.Success) {
          vm.rehber = response.Data;

          vm.isFolyoLoad = true;
        } else {
          vm.$alert.messageWithTitle("Rehber", response.Message, "error");
        }
      });
    }
  },
};
</script>
